import FastMarquee from "react-fast-marquee";
import { Coffee } from "lucide-react";

const EditorialMarquee = ({
  text = "More than Chai, it's an Experience",
  className = "bg-terracotta text-cream",
  speed = 35,
}) => (
  <div className={`py-4 border-y border-charcoal/20 overflow-hidden ${className}`} data-testid="editorial-marquee">
    <FastMarquee speed={speed} gradient={false}>
      {Array.from({ length: 6 }).map((_, i) => (
        <span key={i} className="flex items-center gap-8 mx-8">
          <span className="font-serif italic text-xl md:text-2xl whitespace-nowrap">{text}</span>
          <Coffee size={18} strokeWidth={1.5} />
          <span className="font-mono text-xs uppercase tracking-[0.3em] whitespace-nowrap">Kulhad Chai — Bengaluru</span>
          <Coffee size={18} strokeWidth={1.5} />
        </span>
      ))}
    </FastMarquee>
  </div>
);

export default EditorialMarquee;
